export class Controls {
  constructor(canvas) {
    this.move = { x: 0, z: 0 };
    this.lookDelta = 0;
    this.jumpQueued = false;
    this.keys = new Set();
    this.joystickPointer = null;
    this.joystickOrigin = { x: 0, y: 0 };
    this.dragPointer = null;
    this.dragX = 0;

    this.joystick = document.querySelector("#joystick");
    this.knob = document.querySelector("#joystick-knob");
    this.jumpButton = document.querySelector("#jump-button");

    window.addEventListener("keydown", (event) => {
      if (["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight", "Space"].includes(event.code)) {
        event.preventDefault();
      }
      this.keys.add(event.code);
      if (event.code === "Space") this.jumpQueued = true;
    });
    window.addEventListener("keyup", (event) => this.keys.delete(event.code));
    window.addEventListener("blur", () => this.keys.clear());

    canvas.addEventListener("pointerdown", (event) => {
      if (event.pointerType === "mouse" && event.button !== 0) return;
      this.dragPointer = event.pointerId;
      this.dragX = event.clientX;
    });
    canvas.addEventListener("pointermove", (event) => {
      if (event.pointerId !== this.dragPointer) return;
      this.lookDelta -= (event.clientX - this.dragX) * 0.006;
      this.dragX = event.clientX;
    });
    const stopDrag = (event) => {
      if (event.pointerId === this.dragPointer) this.dragPointer = null;
    };
    canvas.addEventListener("pointerup", stopDrag);
    canvas.addEventListener("pointercancel", stopDrag);

    this.joystick.addEventListener("pointerdown", (event) => {
      event.preventDefault();
      this.joystickPointer = event.pointerId;
      const rect = this.joystick.getBoundingClientRect();
      this.joystickOrigin = { x: rect.left + rect.width / 2, y: rect.top + rect.height / 2 };
      this.joystick.setPointerCapture(event.pointerId);
      this.updateJoystick(event);
    });
    this.joystick.addEventListener("pointermove", (event) => {
      if (event.pointerId === this.joystickPointer) this.updateJoystick(event);
    });
    const stopJoystick = (event) => {
      if (event.pointerId !== this.joystickPointer) return;
      this.joystickPointer = null;
      this.move.x = 0;
      this.move.z = 0;
      this.knob.style.transform = "translate(-50%, -50%)";
    };
    this.joystick.addEventListener("pointerup", stopJoystick);
    this.joystick.addEventListener("pointercancel", stopJoystick);

    const queueJump = (event) => {
      event.preventDefault();
      this.jumpQueued = true;
      this.jumpButton.classList.add("pressed");
    };
    this.jumpButton.addEventListener("pointerdown", queueJump);
    this.jumpButton.addEventListener("pointerup", () => this.jumpButton.classList.remove("pressed"));
    this.jumpButton.addEventListener("pointercancel", () => this.jumpButton.classList.remove("pressed"));
  }

  updateJoystick(event) {
    const dx = event.clientX - this.joystickOrigin.x;
    const dy = event.clientY - this.joystickOrigin.y;
    const distance = Math.hypot(dx, dy);
    const maximum = 38;
    const scale = distance > maximum ? maximum / distance : 1;
    const x = dx * scale;
    const y = dy * scale;
    this.knob.style.transform = `translate(calc(-50% + ${x}px), calc(-50% + ${y}px))`;
    this.move.x = x / maximum;
    this.move.z = -y / maximum;
  }

  sample() {
    let x = this.move.x;
    let z = this.move.z;
    x += Number(this.keys.has("KeyD") || this.keys.has("ArrowRight"));
    x -= Number(this.keys.has("KeyA") || this.keys.has("ArrowLeft"));
    z += Number(this.keys.has("KeyW") || this.keys.has("ArrowUp"));
    z -= Number(this.keys.has("KeyS") || this.keys.has("ArrowDown"));
    const length = Math.hypot(x, z);
    if (length > 1) {
      x /= length;
      z /= length;
    }
    const result = {
      x,
      z,
      jump: this.jumpQueued,
      look: this.lookDelta,
    };
    this.jumpQueued = false;
    this.lookDelta = 0;
    return result;
  }
}
